export default "__VITE_ASSET__89d9fa74__"